/* eslint-disable @next/next/no-img-element */
import React from 'react'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import Doc from 'assets/homepage-redesign/assets/doc.svg'
import GraphImage from 'assets/homepage-redesign/assets/graph.svg'
import { Body2 } from 'stories/elements/Typography/Text'
import _useTranslation from 'lib/hooks/_useTranslation'

const AssetWrapper = styled.div`
    width: 400px;
    height: 335px;
    border-radius: 40px;
    background: #291605;
    position: relative;
    box-shadow: 0px 20px 30px 0px #f7326e80;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    overflow: hidden;
    @media (max-width: 940px) {
        border-radius: 32px !important;
        padding: 0px !important;
    }

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 40px;
        border: 10px solid transparent;
        background: linear-gradient(180deg, #f7326e, #fc7600) border-box;
        -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        pointer-events: none;
        @media (max-width: 940px) {
            border-radius: 32px !important;
            border: 7px solid transparent !important;
        }
    }
`

const ScanFrame = styled.div`
    position: absolute;
    top: 35px;
    left: 40px;
    width: 250px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 7px;
    z-index: 2;
`

const ScanLine = styled.div<{ width: number }>`
    height: 10px;
    width: ${(props) => props.width}px;
    background: #ffffff;
    border-radius: 3px;
`

const GraphContainer = styled.div`
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    width: 96%;
    height: 220px;
    border-radius: 0px 0px 24px 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 80px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));

    img {
        width: 100%;
        height: auto;
        object-fit: contain;
    }
`

const FunctionCard = styled.div`
    position: absolute;
    bottom: 10px;
    left: 8px;
    width: 96%;
    padding: 14px 20px;
    background: linear-gradient(90deg, #291605 0%, #140a03 100%);
    border-top: 1.5px solid #ffffff26;
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: 50px;
    p {
        font-family: var(--font-inter);
        font-weight: 650;
        font-size: 17px;
        line-height: 20px;
        letter-spacing: 0.3px;
        color: #f9f9f9;
    }
    @media (max-width: 940px) {
        width: 96%;
        border-radius: 20px !important;
        display: grid;
        left: 7px;
        grid-template-columns: 48px 1fr auto;
    }
`

const IconWrapper = styled.div`
    width: 45px !important;
    height: 45px !important;
    border-radius: 100%;
    background: linear-gradient(90deg, #d66300, #f7326e);
    border: 1px solid rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        scale: 0.7;
    }
`

const ChevronIcon = styled.div`
    margin-left: auto;
    color: ${theme.colors.white};
    display: flex;
    align-items: center;
    justify-content: center;
`

const AiMockExamAsset: React.FC = () => {
    const { t } = _useTranslation('homepage')

    return (
        <AssetWrapper>
            <ScanFrame>
                <ScanLine width={85} />
                <ScanLine width={135} />
                <ScanLine width={240} />
            </ScanFrame>

            <GraphContainer>
                <GraphImage />
            </GraphContainer>

            <FunctionCard>
                <IconWrapper>
                    <Doc />
                </IconWrapper>
                <Body2 color={theme.colors.white} fontWeight={550} fontSize={16} fontFamily="var(--font-inter)">
                    {t('homepage/aiMockExamTitle')}
                </Body2>
                <ChevronIcon>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9 6L15 12L9 18"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </ChevronIcon>
            </FunctionCard>
        </AssetWrapper>
    )
}

export default AiMockExamAsset
